import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { toast } from 'react-toastify';
import '../styles/Auth.css';

const AgentLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    providerId: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post('/api/auth/login/agent', formData);
      login(res.data.token, res.data.agent, 'agent');
      toast.success('Login successful!');
      navigate('/provider/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Agent Login</h1>
        <p className="auth-subtitle">Access your agent dashboard</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Provider ID</label>
            <input
              type="text"
              name="providerId"
              value={formData.providerId}
              onChange={handleChange}
              placeholder="Enter your organization's Provider ID"
              required
            />
            <small>Contact your organization admin for the Provider ID</small>
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="auth-links">
          <p>Organization admin? <Link to="/login/provider">Provider Login</Link></p>
          <p>Are you an individual? <Link to="/login/user">Individual Login</Link></p>
        </div>
      </div>
    </div>
  );
};

export default AgentLogin;
